import React from "react";
import "../Card/Card.css"; // Use the actual Card styles
import "./ProductSkeleton.css";

/**
 * Skeleton loader for Card/Product components
 * Uses the exact same HTML structure and CSS classes as Card component
 * Only adds skeleton-specific styling for shimmer effects
 */
const ProductSkeleton = ({ count = 6 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="card skeleton-card">
          <div className="product__image__container skeleton-shimmer"></div>
          <div className="card__title__container">
            <div className="skeleton-title skeleton-shimmer"></div>
            <div className="skeleton-price skeleton-shimmer"></div>
          </div>
          <div className="btn-container">
            <div className="skeleton-button skeleton-shimmer"></div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ProductSkeleton;
